import * as React from "react";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";

interface AuthDividerProps {
  text?: string;
  className?: string;
}

/**
 * Auth Divider Component
 *
 * Horizontal divider with optional text (e.g., "or continue with").
 * Used to separate email/password login from social login options.
 */
export function AuthDivider({
  text = "or continue with",
  className,
}: AuthDividerProps) {
  return (
    <div className={cn("relative my-6", className)}>
      <div className="absolute inset-0 flex items-center">
        <Separator className="w-full" />
      </div>
      <div className="relative flex justify-center text-xs uppercase">
        <span className="bg-card px-2 text-muted-foreground">{text}</span>
      </div>
    </div>
  );
}

export default AuthDivider;
